// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__5Oajf","prefix":"Input_prefix__EJWZA","suggestions":"Input_suggestions__rZHoZ"};